import { parseISO } from 'date-fns';

import { RecognitionApiData } from '../../types/recognition';
import { User } from './user';

interface ReferencedRecognitionData {
	id: string;
	date: string;
	giver: User;
	text: string;
}

export class ReferencedRecognition {
	id: string;
	date: Date;
	giver: User;
	text: string;
	type = 'Bonus';

	constructor(data: ReferencedRecognitionData) {
		this.id = data.id;
		this.date = parseISO(data.date);
		this.giver = data.giver;
		this.text = data.text;
	}

	public static fromApiData(data: RecognitionApiData) {
		const giver = User.fromApiData(data.giver);

		return new ReferencedRecognition({
			id: data.id,
			date: data.created_at,
			giver,
			text: data.reason,
		});
	}
}
